import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca44f000"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "m-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Info Kiosk")
], -1))
const _hoisted_2 = { class: "team mb-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Team", -1))
const _hoisted_4 = { class: "team-container" }
const _hoisted_5 = { class: "team-member" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Memphis", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Alpha Lion", -1))
const _hoisted_9 = { class: "team-member" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "RightClickable", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Art Lion", -1))
const _hoisted_13 = { class: "team-member" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "0xNeuroD", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Dev Lion", -1))
const _hoisted_17 = { class: "team-member" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "BittyMcBitface", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Ops Lion", -1))
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" This project is led by ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Memphis")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(", the Alpha Lion, and powered by the team at ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("RightClickable.")
const _hoisted_26 = { class: "mint mb-5" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Mint", -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" \"Minting\"... Minting is the process of attaining an NFT from the Solana blockchain. The mint is now live ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("here")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "roadmap mb-5" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Roadmap"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "p-2" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Summer 2022 - "),
      /*#__PURE__*/_createTextVNode("launch Memphis Lions Club Digital Platform (Memphisverse v0), Discord, and social channels ")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "p-2" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Fall 2022 - "),
      /*#__PURE__*/_createTextVNode("launch the Memphis Lions Club NFT collection ")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "p-2" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Fall 2022 - "),
      /*#__PURE__*/_createTextVNode("launch Memphisverse Metastage v1 ")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "p-2" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Winter 2022 - "),
      /*#__PURE__*/_createTextVNode("launch Memphisverse Metagallery v1 ")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "p-2" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Summer 2023 - "),
      /*#__PURE__*/_createTextVNode("launch Lionesses NFT Collection (4,999 Lionesses 1:1 swappable for Lions) ")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "p-2" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Winter 2023 - "),
      /*#__PURE__*/_createTextVNode("launch Memphisverse Arena v1 partner gamification ")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "p-2" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Spring 2024 - "),
      /*#__PURE__*/_createTextVNode("launch Memphisverse v2 and integrated network of RightClickable Multimetaverses ")
    ])
  ])
], -1))
const _hoisted_32 = { class: "whitelist mb-5" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Whitelist", -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Initially there will be 1,500 whitelist (WL) spots for early adopters and active community members. The number of WL spots will be increased in steps of 1,500 as community milestones are achieved and we progress towards the mint date. Demand for Lions will be high, but we want to start off as we mean to go on, with as many Lions as possible in the hands of those community members who support the project and want to ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" #LiveLikeALion. ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Details on how to participate are available in our ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Discord. ")
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "rarity mb-5" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Rarity"),
  /*#__PURE__*/_createElementVNode("p", null, " The rarity score of your Lion will be calculated and will depend on the number of traits and the number of times each trait occurs in the collection. However, each Lion is unique with its own distinct personality and therefore rarity alone should not be the deciding factor when you become a Lion. ")
], -1))

import PageFooter from '@/components/PageFooter.vue';
import BackButton from '@/components/buttons/BackButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'InfoPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _createVNode(BackButton),
      _hoisted_1,
      _createElementVNode("main", null, [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_b_link, {
                href: "https://twitter.com/Memphis",
                target: "_blank",
                rel: "noopener noreferrer"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "img-thumbnail team-img",
                    src: require('@/assets/team-Memphis-lion.png'),
                    alt: "NFT"
                  }, null, 8, _hoisted_6)
                ]),
                _: 1
              }),
              _hoisted_7,
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_b_link, {
                href: "https://twitter.com/rightclickable",
                target: "_blank",
                rel: "noopener noreferrer"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "img-thumbnail team-img",
                    src: require('@/assets/team-RC-lion.png'),
                    alt: "NFT"
                  }, null, 8, _hoisted_10)
                ]),
                _: 1
              }),
              _hoisted_11,
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_b_link, {
                href: "https://twitter.com/0xNeuroD",
                target: "_blank",
                rel: "noopener noreferrer"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "img-thumbnail team-img",
                    src: require('@/assets/team-0xNeuroD-lion.png'),
                    alt: "NFT"
                  }, null, 8, _hoisted_14)
                ]),
                _: 1
              }),
              _hoisted_15,
              _hoisted_16
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_b_link, {
                href: "https://twitter.com/bittymcbitface",
                target: "_blank",
                rel: "noopener noreferrer"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "img-thumbnail team-img",
                    src: require('@/assets/team-Bitty-lion.png'),
                    alt: "NFT"
                  }, null, 8, _hoisted_18)
                ]),
                _: 1
              }),
              _hoisted_19,
              _hoisted_20
            ])
          ]),
          _createElementVNode("p", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_b_link, {
              href: "https://twitter.com/Memphis",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }),
            _hoisted_24,
            _createVNode(_component_b_link, {
              href: "https://rightclickable.com",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("p", null, [
            _hoisted_28,
            _createVNode(_component_b_link, { to: "gallery" }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }),
            _hoisted_30
          ])
        ]),
        _hoisted_31,
        _createElementVNode("section", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("p", null, [
            _hoisted_34,
            _createVNode(_component_b_link, {
              href: "https://twitter.com/search?q=%23LiveLikeALion",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_35
              ]),
              _: 1
            }),
            _hoisted_36,
            _createVNode(_component_b_link, {
              href: "https://discord.gg/MemphisLionsClub",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_37
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_38
      ]),
      _createVNode(PageFooter, { "no-top-margin": "" })
    ]),
    _: 1
  }))
}
}

})